import { Component } from '@angular/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';

@Component({
  selector: 'app-payment-layout',
  templateUrl: './payment-layout.component.html',
  styleUrls: ['./payment-layout.component.scss']
})

export class PaymentLayoutComponent {

  constructor(public authenticationService: AuthenticationService) {
  }

}
